import { render } from "./courseAnalyseCreate.vue?vue&type=template&id=6f4dcaab&scoped=true"
import script from "./courseAnalyseCreate.vue?vue&type=script&lang=js"
export * from "./courseAnalyseCreate.vue?vue&type=script&lang=js"

import "./courseAnalyseCreate.vue?vue&type=style&index=0&id=6f4dcaab&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4dcaab"]])

export default __exports__